import { actionTypes } from "./storeTypes";

export const init_global = {
  auth: undefined,
  buttonStatus: { Save: false, Style: false, Load: false, Handles: false },
  countryData: null,
  edges: null,
  entityData: null,
  flowConfig: null,
  flowLayout: null,
  focusId: null,
  menuSelection: "Jurisdiction",
  // menuSelectionTrigger: 0,
  mode: null,
  newFlowLayoutTrigger: false,
  nodes: [],
  popup: { active: false, content: "" },
  reset: false,
  screenshotImageDimensions: null,
  screenshotImage: { active: false, image: null },
  selectedCountry: "All", //{value:null,label:null},
  showHandles: false,
  showStyle: false,
  audit_flowSelection: "Flow",
  version: null,
};

export function global_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_AUDIT_FLOW_SELECTION: {
      return {
        ...state,
        audit_flowSelection: action.payload,
      };
    }
    case actionTypes.SET_AUTH: {
      return {
        ...state,
        auth: action.payload,
      };
    }
    case actionTypes.SET_BUTTONSTATUS: {
      return {
        ...state,
        buttonStatus: action.payload,
      };
    }
    case actionTypes.SET_COUNTRY_DATA: {
      return {
        ...state,
        countryData: action.payload,
      };
    }
    case actionTypes.SET_EDGES: {
      return {
        ...state,
        edges: action.payload,
      };
    }
    case actionTypes.SET_ENTITY_DATA: {
      return {
        ...state,
        entityData: action.payload,
      };
    }
    case actionTypes.SET_FLOWCONFIG: {
      return {
        ...state,
        flowConfig: action.payload,
      };
    }
    case actionTypes.SET_FLOWLAYOUT: {
      return {
        ...state,
        flowLayout: action.payload,
      };
    }
    case actionTypes.SET_FOCUSID: {
      return {
        ...state,
        focusId: action.payload,
      };
    }
    case actionTypes.SET_MENU_SELECTION: {
      return {
        ...state,
        menuSelection: action.payload,
      };
    }
    case actionTypes.SET_MODE: {
      return {
        ...state,
        mode: action.payload,
      };
    }
    case actionTypes.SET_NEWFLOWLAYOUTTRIGGER: {
      return {
        ...state,
        newFlowLayoutTrigger: action.payload,
      };
    }
    case actionTypes.SET_NODES: {
      return {
        ...state,
        nodes: action.payload,
      };
    }
    case actionTypes.SET_POPUP: {
      return {
        ...state,
        popup: action.payload,
      };
    }
    case actionTypes.SET_RESET: {
      return {
        ...state,
        reset: action.payload,
      };
    }
    case actionTypes.SET_SCREENSHOT_IMAGE: {
      return {
        ...state,
        screenshotImage: action.payload,
      };
    }
    case actionTypes.SET_SCREENSHOT_IMAGE_DIMENSIONS: {
      return {
        ...state,
        screenshotImageDimensions: action.payload,
      };
    }
    case actionTypes.SET_SELECTED_COUNTRY: {
      return {
        ...state,
        selectedCountry: action.payload,
      };
    }
    case actionTypes.SET_SHOWHANDLES: {
      return {
        ...state,
        showHandles: action.payload,
      };
    }
    case actionTypes.SET_SHOWSTYLE: {
      return {
        ...state,
        showStyle: action.payload,
      };
    }
    case actionTypes.SET_VERSION: {
      return {
        ...state,
        version: action.payload,
      };
    }
    default:
      return state;
  }
}
